var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNatureOfBusinessCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 15.6039,
    fill: "#3158F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9638,
    y: 22.5566,
    width: 21.5331,
    height: 14.3554,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5824 37.8959V22.6076C38.5824 22.0185 38.1049 21.541 37.5158 21.541H32.7414",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5824 37.8959V22.6076C38.5824 22.0185 38.1049 21.541 37.5158 21.541H32.7414",
    stroke: "white",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.393 21.541H18.6185C18.0295 21.541 17.5519 22.0185 17.5519 22.6076V37.8959",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.393 21.541H18.6185C18.0295 21.541 17.5519 22.0185 17.5519 22.6076V37.8959",
    stroke: "white",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7414 25.045H35.6619",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7414 28.5489H35.6619",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7414 32.0509H35.6619",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4749 25.045H23.3954",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4749 28.5489H23.3954",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4749 32.0509H23.3954",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7502 37.8946H16.3861",
    stroke: "white",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3924 37.8949V18.0354C23.3924 17.3902 23.9154 16.8672 24.5606 16.8672H31.5698C32.215 16.8672 32.738 17.3902 32.738 18.0354V37.8949",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3924 37.8949V18.0354C23.3924 17.3902 23.9154 16.8672 24.5606 16.8672H31.5698C32.215 16.8672 32.738 17.3902 32.738 18.0354V37.8949",
    stroke: "white",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3153 28.5489H29.8199",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3153 32.0509H29.8199",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3153 25.045H29.8199",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3153 21.5372H29.8199",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0654 35.5586V37.895",
    stroke: "#3158F2",
    strokeWidth: 1.17135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatureOfBusinessCheckLarge);
export default __webpack_public_path__ + "static/media/nature_of_business_check_large.169f35849d6d32de5c503b89ca865cf6.svg";
export { ForwardRef as ReactComponent };